import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const AvisoPrivacidad = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-r from-[#0f2a5e] via-[#1a4a9f] to-[#1e6fd9]">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h1 className="text-4xl lg:text-5xl font-bold text-white mb-4">Aviso de Privacidad</h1>
          <p className="text-white/80 text-lg">CX Comercializadora de Puebla — Protección de datos personales</p>
        </div>
      </section>
      
      {/* Contenido */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6">
          <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed space-y-8">
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">1. Identidad del Responsable</h2>
              <p className="text-base">
                <strong>CX Comercializadora de Puebla</strong>, con domicilio en Puebla, Puebla, México, es responsable del tratamiento de sus datos personales conforme a lo dispuesto por la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP) y su Reglamento.
              </p>
              <p className="text-base">
                Correo electrónico de contacto:{' '}
                <a
                  href="mailto:cxventas.com.pue@gmail.com"
                  className="text-blue-700 hover:text-blue-800 cursor-pointer"
                  rel="nofollow"
                >
                  cxventas.com.pue@gmail.com
                </a>
              </p>
            </div>
            
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">2. Datos Personales Recabados</h2>
              <p className="text-base">
                Para las finalidades señaladas en el presente aviso de privacidad, podemos recabar los siguientes datos personales:
              </p>
              <ul className="list-disc pl-6 space-y-1 text-base">
                <li>Nombre completo</li>
                <li>Correo electrónico</li>
                <li>Número telefónico</li>
                <li>Nombre de la empresa u organización</li>
                <li>Dirección de entrega</li>
                <li>Datos fiscales (RFC, razón social, domicilio fiscal) para facturación</li>
              </ul>
            </div>
            
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">3. Finalidades del Tratamiento</h2>
              <p className="text-base">
                Sus datos personales serán utilizados para las siguientes finalidades primarias:
              </p>
              <ul className="list-disc pl-6 space-y-1 text-base">
                <li>Atender solicitudes de cotización y requisiciones de productos</li>
                <li>Procesar pedidos, entregas y facturación</li>
                <li>Brindar atención al cliente y seguimiento postventa</li>
                <li>Dar cumplimiento a obligaciones legales y fiscales</li>
              </ul>
              <p className="text-base mt-4">De manera secundaria, sus datos podrán ser utilizados para:</p>
              <ul className="list-disc pl-6 space-y-1 text-base">
                <li>Envío de información sobre promociones, nuevos productos y servicios</li>
                <li>Realización de encuestas de satisfacción</li>
                <li>Análisis estadísticos internos para mejorar nuestros servicios</li>
              </ul>
            </div>
            
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">4. Transferencia de Datos</h2>
              <p className="text-base">
                CX Comercializadora de Puebla no transferirá sus datos personales a terceros sin su consentimiento, salvo las excepciones previstas en el artículo 37 de la LFPDPPP, tales como requerimientos de autoridades competentes debidamente fundados y motivados.
              </p>
            </div>
            
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">5. Derechos ARCO</h2>
              <p className="text-base">
                Usted tiene derecho a conocer qué datos personales tenemos de usted, para qué los utilizamos y las condiciones del uso que les damos (Acceso). Asimismo, es su derecho solicitar la corrección de su información personal en caso de que esté desactualizada, sea inexacta o incompleta (Rectificación); que la eliminemos de nuestros registros o bases de datos cuando considere que la misma no está siendo utilizada adecuadamente (Cancelación); así como oponerse al uso de sus datos personales para fines específicos (Oposición).
              </p>
              <p className="text-base">
                Para ejercer sus derechos ARCO, puede enviar una solicitud al correo electrónico:{' '}
                <a
                  href="mailto:cxventas.com.pue@gmail.com"
                  className="text-blue-700 hover:text-blue-800 cursor-pointer"
                  rel="nofollow"
                >
                  cxventas.com.pue@gmail.com
                </a>
                , indicando su nombre completo, los datos que desea ejercer y una breve descripción de su solicitud.
              </p>
            </div>
            
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">6. Uso de Cookies y Tecnologías de Rastreo</h2>
              <p className="text-base">
                Nuestro sitio web puede utilizar cookies y otras tecnologías de rastreo para mejorar su experiencia de navegación, analizar el tráfico del sitio y personalizar el contenido. Usted puede deshabilitar las cookies a través de la configuración de su navegador; sin embargo, esto podría afectar algunas funcionalidades del sitio.
              </p>
            </div>
            
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">7. Modificaciones al Aviso de Privacidad</h2>
              <p className="text-base">
                CX Comercializadora de Puebla se reserva el derecho de efectuar en cualquier momento modificaciones o actualizaciones al presente aviso de privacidad. Dichas modificaciones estarán disponibles a través de nuestro sitio web.
              </p>
            </div>
            
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">8. Consentimiento</h2>
              <p className="text-base">
                Al proporcionar sus datos personales a través de nuestros formularios de contacto, correo electrónico, WhatsApp u otros medios de comunicación, usted consiente el tratamiento de los mismos conforme a los términos del presente aviso de privacidad.
              </p>
            </div>
            
            <div className="bg-blue-50 rounded-xl p-6 border border-blue-100">
              <p className="text-sm text-gray-600">
                <strong>Última actualización:</strong> Enero 2025
              </p>
              <p className="text-sm text-gray-600 mt-1">
                Si tiene alguna duda sobre este aviso de privacidad, puede contactarnos en:{' '}
                <a
                  href="mailto:cxventas.com.pue@gmail.com"
                  className="text-blue-700 hover:text-blue-800 cursor-pointer"
                  rel="nofollow"
                >
                  cxventas.com.pue@gmail.com
                </a>
              </p>
            </div>
          </div>
          
          <div className="mt-12 text-center">
            <Link
              to="/"
              className="inline-flex items-center gap-2 bg-gradient-to-r from-[#1e3a5f] to-[#2d5a8c] text-white px-8 py-3 rounded-lg font-semibold hover:opacity-90 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-arrow-left-line" aria-hidden="true"></i>
              Volver al Inicio
            </Link>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default AvisoPrivacidad;